import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  components,
  formLabelsTheme,
  getValueType,
  iconError,
  selectStyles,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectParameter4,
} from "../businessParameter/businessParameterSlice";
// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { selectCountryAll } from "../location/locationSlice";
import {
  addVehicle,
  editVehicle,
  fetchIdInbound,
  fetchVehicle,
  selectIdInbound,
  selectInbound,
} from "./inboundSlice";
import { ModalProductRadio } from "./ModalProductRadio";
import { ModalModelRadio } from "./ModalModelRadio";
import { ModalColorRadio } from "./ModalColorRadio";
import moment from "moment";
import { selectPagination } from "../../modules/Auth";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const VehicleCreate = ({
  isOpen,
  setShow,
  handleSearch,
  setFormValues,
  formValues,
  row,
  setRow,
  getDataProduct,
  setGetDataProduct,
  getDataModel,
  setGetDataModel,
  getDataColor,
  setGetDataColor,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataId = useSelector(selectIdInbound);
  const dataVolume = useSelector(selectParameter);
  const dataWeigth = useSelector(selectParameter2);
  const dataUom = useSelector(selectParameter3);
  const dataDistance = useSelector(selectParameter4);
  const paginationSet = useSelector(selectPagination);

  const { id } = useParams();

  useEffect(() => {
    if (row !== null) {
      console.log(row, "jalan");
      setFormValues({
        master_code: {
          value: row.master_code,
          error: false,
          required: "Y",
        },
        master_code_name: {
          value: row.master_code_name,
          error: false,
          required: "Y",
        },
        von: {
          value: row.von,
          error: false,
          required: "N",
        },
        model_code: {
          value: row.model_code,
          error: false,
          required: "N",
        },
        model_code_name: {
          value: row.model_code_name,
          error: false,
          required: "N",
        },

        model_name: {
          value: row.model_name,
          error: false,
          required: "N",
        },

        model_year: {
          value: row.model_year,
          error: false,
          required: "N",
        },
        engine_no: {
          value: row.engine_no,
          error: false,
          required: "N",
        },
        vin: {
          value: row.vin,
          error: false,
          required: "Y",
        },
        product_desc: {
          value: row.product_description,
          error: false,
          required: "N",
        },
        color_code: {
          value: row.color_code,
          error: false,
          required: "N",
        },
        color_code_name: {
          value: row.color_code_name,
          error: false,
          required: "N",
        },
        color_name: {
          value: row.color_name,
          error: false,
          required: "N",
        },
        production_date: {
          value:
            row.production_date === null
              ? ""
              : moment(row.production_date).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        key_no: {
          value: row.key_no,
          error: false,
          required: "N",
        },
        baseuom: {
          value: row.vehicle_uom,
          error: false,
          required: "N",
        },
        net_weight: {
          value: row.vehicle_netweight,
          error: false,
          required: "N",
        },
        gross_weight: {
          value: row.vehicle_grossweight,
          error: false,
          required: "N",
        },
        weight_type: {
          value: row.vehicle_measurement,
          error: false,
          required: "N",
        },
        length: {
          value: row.vehicle_length,
          error: false,
          required: "N",
        },
        width: {
          value: row.vehicle_width,
          error: false,
          required: "N",
        },
        heigth: {
          value: row.vehicle_height,
          error: false,
          required: "N",
        },
        dimension_uom: {
          value: row.vehicle_dimension,
          error: false,
          required: "N",
        },
        volume: {
          value: row.vehicle_volume,
          error: false,
          required: "N",
        },
        volume_uom: {
          value: row.vehicle_typedimension,
          error: false,
          required: "N",
        },
        inbound_rule: {
          value: row.inbound_rule,
          error: false,
          required: "N",
        },
      });
    }
  }, [row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      inbound_id: id,
      client: dataId.client,
      vehicle_id: row !== null ? row.vehicle_id : "",
      master_code: formValues.master_code.value,
      vin: formValues.vin.value,
      von: formValues.von.value,
      model_code: formValues.model_code.value,
      product_description: formValues.product_desc.value,
      color_code: formValues.color_code.value,
      model_name: formValues.model_name.value,
      color_name: formValues.color_name.value,
      model_year: formValues.model_year.value,
      production_date: formValues.production_date.value,
      engine_no: formValues.engine_no.value,
      key_no: formValues.key_no.value,
      vehicle_uom: formValues.baseuom.value,
      vehicle_netweight: formValues.net_weight.value,
      vehicle_grossweight: formValues.gross_weight.value,
      vehicle_measurement: formValues.weight_type.value,
      vehicle_length: formValues.length.value,
      vehicle_width: formValues.width.value,
      vehicle_height: formValues.heigth.value,
      vehicle_dimension: formValues.dimension_uom.value,
      vehicle_volume: formValues.volume.value,
      vehicle_typedimension: formValues.volume_uom.value,
      inbound_rule: formValues.inbound_rule.value,
    };

    if (row === null) {
      delete params.vehicle_id;
    }

    console.log(params, "params");

    try {
      const response =
        row === null
          ? await dispatch(addVehicle(params))
          : await dispatch(editVehicle(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await dispatch(
          fetchVehicle({
            inbound_id: id,
            pageNo: 1,
            pageSize: paginationSet,
          })
        );
        await window.scrollTo(0, 850);
        await handleClose();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const volumeOptions = dataVolume.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeVolume = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["volume_uom"]: {
        ...formValues["volume_uom"],
        value,
      },
    });
  };

  const uomOptions = dataUom.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeUom = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["baseuom"]: {
        ...formValues["baseuom"],
        value,
      },
    });
  };

  const weigthOptions = dataWeigth.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeWeigth = (e, params) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["weight_type"]: {
        ...formValues["weight_type"],
        value,
      },
    });
  };

  const indexUom = uomOptions.findIndex(
    (obj) => obj.value === formValues.baseuom.value
  );

  const distanceOptions = dataDistance.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeDistance = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["dimension_uom"]: {
        ...formValues["dimension_uom"],
        value,
      },
    });
  };

  const [showProduct, setShowProduct] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [showColor, setShowColor] = useState(false);

  const [fieldsProduct, setFieldsProduct] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const handleClose = (e) => {
    setFormValues({
      master_code: {
        value: "",
        error: false,
        required: "Y",
      },
      master_code_name: {
        value: "",
        error: false,
        required: "Y",
      },
      von: {
        value: "",
        error: false,
        required: "N",
      },
      model_code: {
        value: "",
        error: false,
        required: "N",
      },
      model_code_name: {
        value: "",
        error: false,
        required: "N",
      },

      model_name: {
        value: "",
        error: false,
        required: "N",
      },

      model_year: {
        value: "",
        error: false,
        required: "N",
      },
      engine_no: {
        value: "",
        error: false,
        required: "N",
      },
      vin: {
        value: "",
        error: false,
        required: "Y",
      },
      product_desc: {
        value: "",
        error: false,
        required: "N",
      },
      color_code: {
        value: "",
        error: false,
        required: "N",
      },
      color_code_name: {
        value: "",
        error: false,
        required: "N",
      },
      color_name: {
        value: "",
        error: false,
        required: "N",
      },
      production_date: {
        value: "",
        error: false,
        required: "N",
      },
      key_no: {
        value: "",
        error: false,
        required: "N",
      },
      baseuom: {
        value: "UNT",
        error: false,
        required: "Y",
      },
      net_weight: {
        value: "",
        error: false,
        required: "N",
      },
      gross_weight: {
        value: "",
        error: false,
        required: "N",
      },
      weight_type: {
        value: "",
        error: false,
        required: "N",
      },
      length: {
        value: "",
        error: false,
        required: "N",
      },
      width: {
        value: "",
        error: false,
        required: "N",
      },
      heigth: {
        value: "",
        error: false,
        required: "N",
      },
      dimension_uom: {
        value: "",
        error: false,
        required: "N",
      },
      volume: {
        value: "",
        error: false,
        required: "N",
      },
      volume_uom: {
        value: "",
        error: false,
        required: "N",
      },
      inbound_rule: {
        value: "N",
        error: false,
        required: "N",
      },
    });
    setRow(null);
    setShow(false);
  };

  console.log(dataId.inbound_status, "dataId.inbound_status ");
  console.log(dataId, "dataId.inbound_status ");

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            {row === null ? "Add" : "Update"} Vehicle
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <div>
              <p className="font-weight-boldest">Basic Detail</p>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Row>
                    <Col xs={10} sm={3} md={9} lg={9}>
                      <RedditTextField
                        required
                        label="Master Code"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        value={formValues.master_code_name.value}
                        disabled={dataId.inbound_status !== "1010"}
                        error={formValues.master_code.error}
                        helperText={
                          formValues.master_code.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1}>
                      <div>
                        <a
                          className={`display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5 ${
                            dataId.inbound_status !== "1010" ? "disabled" : ""
                          }`}
                        >
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => {
                              setGetDataProduct(true);

                              setShowProduct(true);
                            }}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                    {formValues.master_code.value !== "" &&
                      dataId.inbound_status === "1010" && (
                        <div
                          className="ml-5"
                          style={{ marginTop: "22px", cursor: "pointer" }}
                          onClick={() => {
                            setFormValues({
                              ...formValues,
                              ["master_code"]: {
                                ...formValues["master_code"],
                                value: "",
                              },
                              ["master_code_name"]: {
                                ...formValues["master_code_name"],
                                value: "",
                              },
                              ["product_desc"]: {
                                ...formValues["product_desc"],
                                value: "",
                              },
                            });
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/x-square.svg"
                              )}
                            />
                          </span>
                        </div>
                      )}
                  </Row>
                  <RedditTextField
                    inputProps={{ maxLength: 252 }}
                    label="VON"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="von"
                    onChange={handleChange}
                    value={formValues.von.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                  <Row>
                    <Col xs={10} sm={3} md={9} lg={9}>
                      <RedditTextField
                        label="Model Code"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        value={formValues.model_code_name.value}
                        disabled={dataId.inbound_status !== "1010"}
                      />
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1}>
                      <div>
                        <a
                          className={`display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5 ${
                            dataId.inbound_status !== "1010" ? "disabled" : ""
                          }`}
                        >
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => {
                              setGetDataModel(true);

                              setShowModel(true);
                            }}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                    {formValues.model_code.value !== "" &&
                      dataId.inbound_status === "1010" && (
                        <div
                          className="ml-5"
                          style={{ marginTop: "22px", cursor: "pointer" }}
                          onClick={() => {
                            setFormValues({
                              ...formValues,
                              ["model_code"]: {
                                ...formValues["model_code"],
                                value: "",
                              },
                              ["model_code_name"]: {
                                ...formValues["model_code_name"],
                                value: "",
                              },
                              ["model_name"]: {
                                ...formValues["model_name"],
                                value: "",
                              },
                            });
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/x-square.svg"
                              )}
                            />
                          </span>
                        </div>
                      )}
                  </Row>
                  <RedditTextField
                    label="Model Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="model_name"
                    onChange={handleChange}
                    value={formValues.model_name.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                  <RedditTextField
                    label="Model Year"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="model_year"
                    onChange={handleChange}
                    value={formValues.model_year.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                  <RedditTextField
                    label="Engine No"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="engine_no"
                    onChange={handleChange}
                    value={formValues.engine_no.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {" "}
                  <RedditTextField
                    required
                    label="VIN"
                    inputProps={{ maxLength: 252 }}
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="vin"
                    value={formValues.vin.value}
                    onChange={handleChange}
                    error={formValues.vin.error}
                    helperText={
                      formValues.vin.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                    disabled={dataId.inbound_status !== "1010"}
                  />
                  <RedditTextField
                    inputProps={{ maxLength: 255 }}
                    label="Product Description"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="product_desc"
                    onChange={handleChange}
                    value={formValues.product_desc.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                  <Row>
                    <Col xs={10} sm={3} md={9} lg={9}>
                      <RedditTextField
                        label="Color Code"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        value={formValues.color_code_name.value}
                        disabled={dataId.inbound_status !== "1010"}
                      />
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1}>
                      <div>
                        <a
                          className={`display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5 ${
                            dataId.inbound_status !== "1010" ? "disabled" : ""
                          }`}
                        >
                          {" "}
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => {
                              setGetDataColor(true);
                              setShowColor(true);
                            }}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                    {formValues.color_code.value !== "" &&
                      dataId.inbound_status === "1010" && (
                        <div
                          className="ml-5"
                          style={{ marginTop: "22px", cursor: "pointer" }}
                          onClick={() => {
                            setFormValues({
                              ...formValues,
                              ["color_code"]: {
                                ...formValues["color_code"],
                                value: "",
                              },
                              ["color_code_name"]: {
                                ...formValues["color_code_name"],
                                value: "",
                              },
                              ["color_name"]: {
                                ...formValues["color_name"],
                                value: "",
                              },
                            });
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/x-square.svg"
                              )}
                            />
                          </span>
                        </div>
                      )}
                  </Row>
                  <RedditTextField
                    inputProps={{ maxLength: 255 }}
                    label="Color Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="color_name"
                    onChange={handleChange}
                    value={formValues.color_name.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                  <RedditTextField
                    inputProps={{ maxLength: 255 }}
                    label="Production Date"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="date"
                    name="production_date"
                    onChange={handleChange}
                    value={formValues.production_date.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                  <RedditTextField
                    inputProps={{ maxLength: 255 }}
                    label="Key No"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="key_no"
                    onChange={handleChange}
                    value={formValues.key_no.value}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                </Col>
              </Row>
            </div>
            <hr />

            <div>
              <p className="font-weight-boldest">Weight & Measurement</p>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Autocomplete
                    disablePortal
                    name="baseuom"
                    options={uomOptions}
                    getOptionLabel={(option) => option.label.toString()}
                    disableClearable={true}
                    onChange={handleChangeUom}
                    value={uomOptions[indexUom]}
                    renderInput={(params) => (
                      <RedditTextField
                        required
                        className={classes.margin}
                        {...params}
                        label="Base UOM"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        placeholder="Select"
                        name="baseuom"
                        error={formValues.baseuom.error}
                        helperText={
                          formValues.baseuom.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                        disabled={dataId.inbound_status !== "1010"}
                      />
                    )}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Row>
                    <Col md={4}>
                      <RedditTextField
                        label="Net Weight"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        type="number"
                        name="net_weight"
                        value={formValues.net_weight.value}
                        onChange={handleChange}
                        disabled={dataId.inbound_status !== "1010"}
                      />
                    </Col>
                    <Col md={4}>
                      <RedditTextField
                        label="Gross Weight"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        type="number"
                        name="gross_weight"
                        value={formValues.gross_weight.value}
                        onChange={handleChange}
                        disabled={dataId.inbound_status !== "1010"}
                      />
                    </Col>
                    <Col md={4}>
                      <Select
                        options={weigthOptions}
                        value={getValueType(
                          formValues.weight_type.value,
                          weigthOptions
                        )}
                        placeholder="Select"
                        onChange={handleChangeWeigth}
                        className="mt-4 "
                        isDisabled={dataId.inbound_status !== "1010"}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div>
              <p className="font-weight-boldest">Dimension</p>
              <Row>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <RedditTextField
                    label="Length"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="length"
                    value={formValues.length.value}
                    onChange={handleChange}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                </Col>
                <p className="font-weight-boldest ml-4 mt-7">X</p>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <RedditTextField
                    label="Width"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="width"
                    value={formValues.width.value}
                    onChange={handleChange}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                </Col>
                <p className="font-weight-boldest ml-4 mt-7">X</p>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <RedditTextField
                    label="Heigth"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="heigth"
                    value={formValues.heigth.value}
                    onChange={handleChange}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                </Col>
                <Col>
                  <Select
                    options={distanceOptions}
                    value={getValueType(
                      formValues.dimension_uom.value,
                      distanceOptions
                    )}
                    onChange={handleChangeDistance}
                    className="mt-4 ml-3"
                    isDisabled={dataId.inbound_status !== "1010"}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <RedditTextField
                    label="Volume"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    type="number"
                    name="volume"
                    value={formValues.volume.value}
                    onChange={handleChange}
                    disabled={dataId.inbound_status !== "1010"}
                  />
                </Col>

                <Col md={3}>
                  <Select
                    options={volumeOptions}
                    value={getValueType(
                      formValues.volume_uom.value,
                      volumeOptions
                    )}
                    onChange={handleChangeVolume}
                    className="mt-4 ml-3"
                    isDisabled={dataId.inbound_status !== "1010"}
                  />
                </Col>
              </Row>
            </div>

            <hr />
            <div>
              <p className="font-weight-boldest">Product Profile</p>
              <div className="m-3">
                <p className="font-weight-boldest">Inbound Rule</p>

                <Form.Check
                  inline
                  label="Require Accessories Installation"
                  name="group1"
                  type="checkbox"
                  className="ml-5 mb-4 mt-4"
                  onChange={(e) => {
                    if (e.target.checked === true) {
                      setFormValues({
                        ...formValues,
                        ["inbound_rule"]: {
                          ...formValues["inbound_rule"],
                          value: "Y",
                        },
                      });
                    } else {
                      setFormValues({
                        ...formValues,
                        ["inbound_rule"]: {
                          ...formValues["inbound_rule"],
                          value: "N",
                        },
                      });
                    }
                  }}
                  checked={formValues.inbound_rule.value === "Y" ? true : false}
                  disabled={dataId.inbound_status !== "1010"}
                />
              </div>{" "}
            </div>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {dataId.inbound_status === "1010" && (
            <Button onClick={handleSave} variant="primary">
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ModalProductRadio
        isOpen={showProduct}
        setShow={setShowProduct}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsProduct}
        fields={fieldsProduct}
        getData={getDataProduct}
        setGetData={setGetDataProduct}
      />

      <ModalModelRadio
        isOpen={showModel}
        setShow={setShowModel}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsProduct}
        fields={fieldsProduct}
        getData={getDataModel}
        setGetData={setGetDataModel}
      />

      <ModalColorRadio
        isOpen={showColor}
        setShow={setShowColor}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsProduct}
        fields={fieldsProduct}
        getData={getDataColor}
        setGetData={setGetDataColor}
      />
    </>
  );
};
